import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
export function MenubarLayout({ menubar, children }) {
    return (_jsxs("div", { className: clsx([
            // Basic layout
            'flex h-full w-full flex-col',
            // Background color
            'bg-white',
            // Dark mode
            'dark:bg-zinc-950'
        ]), children: [_jsx("div", { className: clsx([
                    // Border
                    'border-b border-zinc-950/10 dark:border-white/10',
                    // Backdrop
                    'backdrop-blur-sm dark:backdrop-blur',
                    // Background
                    'bg-white/7.5 dark:bg-zinc-900/7.5'
                ]), children: menubar }), _jsx("div", { className: "h-0 flex-grow overflow-hidden", children: children })] }));
}
